// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__m2jPc","withoutImg":"Avatar_withoutImg__60+Mq"};